export default __webpack_public_path__ + "static/media/CONTACTO.2ba07117.png";